import { MainContentLayout } from 'shared/ui/layout';

import { AddCpo } from 'features/cpo/add';

export function AddCpoPage() {
  return <MainContentLayout element={<AddCpo />} />;
}
